module.exports = __webpack_public_path__ + "img/h5banner.c23ada58.jpg";